import "./LootboxBanner.scss";
import "../../../../../CasePage/CasePage.scss"; // стилі анімованого ящика (CrateArt)
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import {PATHS_API} from "../../../../../../../enum";
import {PATHS} from "../../../../../../routers/utils/Paths.links";
import {useI18n} from "../../../../../../i18n/I18nProvider";
import {CrateArt} from "../../../../../CasePage/CaseArt";

// Рекламний банер ящика в сітці товарів (на ширину двох карток): назва, короткий рядок із цінами й кнопка
const LootboxBanner = () => {
    const { t } = useI18n();
    const [info, setInfo] = useState<{ price: number, max: number } | null>(null);

    useEffect(() => {
        axios.get(PATHS_API.LOOTBOX)
            .then(({ data }) => setInfo({
                price: data.price,
                max: Math.max(0, ...data.items.map((i: { price: number }) => i.price)),
            }))
            .catch(() => setInfo(null));
    }, []);
    return (
        <Link to={PATHS.CASE} className="lb-banner" aria-label={t("case.title")}>
            <div className="lb-rays" aria-hidden="true" />
            <div className="lb-sparks" aria-hidden="true">
                { Array.from({ length: 8 }, (_, i) => <span key={i} style={{ "--d": i } as React.CSSProperties} />) }
            </div>

            <div className="lb-text">
                <h4 className="lb-title">{t("case.title")}</h4>
                { info &&
                    <span className="lb-sub">
                        <span>{t("banner.shortPrice", { price: info.price })}</span>
                        <span>{t("banner.shortMax", { max: info.max })}</span>
                    </span>
                }
                <span className="lb-cta">{t("banner.cta")} <span aria-hidden="true">→</span></span>
            </div>

            <div className="lb-art">
                <CrateArt className="lb-crate" />
            </div>
        </Link>
    );
};

export default LootboxBanner;
